module.exports = __webpack_public_path__ + "img/old-fashioned-potato-salad.3d2d1bee.jpg";